var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('order-summary-item',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"hotel-info__header"},[_c('div',{staticClass:"hotel-info__header__hotel-name"},[_vm._v(_vm._s(_vm.hotel.name))]),_vm._v(" "),_c('stars',{attrs:{"countStars":_vm.hotel.stars}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }